import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-iws-nb-teaser-contact",
    styleUrl: "nb-teaser-contact.scss",
})
export class NbTeaserContact {
    private static uidIncrement = 0;
    private uid = `nb-teaser-contact-${NbTeaserContact.uidIncrement++}`;

    /** Url of the image */
    @Prop() imageUrl: string = "";
    /** Alt text used to describe the image (Accessibility) */
    @Prop() imageAlt: string = "";
    /** Heading level used to render the headline and subheadline */
    @Prop() headingLevel: 2 | 3 | 4 = 3;
    /** Text used for the headline */
    @Prop() headline: string = "";
    /** Text used for the subheadline */
    @Prop() subheadline: string = "";
    /** Text used for the description */
    @Prop() description: string = "";
    /** Headline for the contacts section */
    @Prop() contactHeadline: string = "Contact";
    /** Label for the contact phone link */
    @Prop() contactPhoneLabel: string = "";
    /** Contact phone number (full phone number including country prefix, e.g. +49) */
    @Prop() contactPhoneNumber: string = "";
    /** Label for the contact email link */
    @Prop() contactEmailLabel: string = "";
    /** Contact email address */
    @Prop() contactEmailAddress: string = "";
    /** Label for the service link */
    @Prop() contactServiceLabel: string = "";
    /** URL of the service link */
    @Prop() contactServiceLink: string = "";
    /** Target of the service link */
    @Prop() contactServiceTarget: string = "_blank";

    componentWillLoad() {
        if (this.headingLevel < 2 || this.headingLevel > 4) {
            this.headingLevel = 3;
        }
    }

    render() {
        const baseClass = "ux-iws-nb-teaser-contact";
        const HeadingTag = `h${this.headingLevel}`;
        const ContactHeadingTag = `h${this.headingLevel + 1}`;
        return (
            <Host
                class={{
                    [baseClass]: true,
                    [`${baseClass}--no-image`]: !this.imageUrl,
                }}
            >
                <article
                    class={`${baseClass}__container`}
                    aria-labelledby={`${this.uid}-headline`}
                >
                    <div class="ux-row ux-u-mx-zero">
                        <div class="ux-col-12 ux-col-lg-10 ux-u-offset-lg-1 ux-u-pos-relative">
                            {this.imageUrl && (
                                <div class={`${baseClass}__image`}>
                                    <img
                                        src={this.imageUrl}
                                        alt={this.imageAlt}
                                    />
                                </div>
                            )}
                            <div class={`${baseClass}__box`}>
                                <div class={`${baseClass}__header`}>
                                    <HeadingTag
                                        class={`${baseClass}__headline`}
                                        id={`${this.uid}-headline`}
                                    >
                                        <span>{this.headline}</span>
                                        {this.subheadline && (
                                            <span>{this.subheadline}</span>
                                        )}
                                    </HeadingTag>
                                    {this.description && (
                                        <p class="ux-text-normal">
                                            {this.description}
                                        </p>
                                    )}
                                </div>
                                <section
                                    class={`${baseClass}__contacts`}
                                    aria-labelledby={`${this.uid}-contacts-headline`}
                                >
                                    <ContactHeadingTag
                                        id={`${this.uid}-contacts-headline`}
                                    >
                                        {this.contactHeadline}
                                    </ContactHeadingTag>
                                    <div
                                        class={`${baseClass}__contacts__content`}
                                    >
                                        {this.contactPhoneLabel &&
                                            this.contactPhoneNumber && (
                                                <a
                                                    class={`${baseClass}__phone`}
                                                    href={`tel:${this.contactPhoneNumber.replace(/[\s]/g, "")}`}
                                                >
                                                    <span>
                                                        {this.contactPhoneLabel}
                                                        &nbsp;
                                                        {
                                                            this
                                                                .contactPhoneNumber
                                                        }
                                                    </span>
                                                </a>
                                            )}
                                        <div class={`${baseClass}__links`}>
                                            {this.contactEmailLabel &&
                                                this.contactEmailAddress && (
                                                    <a
                                                        class={`${baseClass}__link`}
                                                        href={`mailto:${this.contactEmailAddress}`}
                                                    >
                                                        <span>
                                                            {
                                                                this
                                                                    .contactEmailLabel
                                                            }
                                                        </span>
                                                        <ux-icon name="arrow-right" />
                                                    </a>
                                                )}
                                            {this.contactServiceLabel &&
                                                this.contactServiceLink && (
                                                    <a
                                                        class={`${baseClass}__link`}
                                                        href={
                                                            this
                                                                .contactServiceLink
                                                        }
                                                        target={
                                                            this
                                                                .contactServiceTarget
                                                        }
                                                    >
                                                        <span>
                                                            {
                                                                this
                                                                    .contactServiceLabel
                                                            }
                                                        </span>
                                                        <ux-icon name="arrow-right" />
                                                    </a>
                                                )}
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </article>
            </Host>
        );
    }
}
